/**
 * @description: 登录信息
 * @return {*}
 */
export class User {
  userId: string = '';
  userName: string = '';
  userAvatar: string = '';
  role: string = "";
  roleId: string = '';
  tenantId: string = '';
  token: string = '';
  lang: string = "";
  userType: number | undefined;
}
